import React, { useState, useEffect } from 'react';
import '../../styles/Navbar.css';
import logoBlack from '../../../images/Logo/MrSea2025_logo_black.png';
import logoWhite from '../../../images/Logo/MrSea2025_logo_white.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import CustomBoatLeadModal from '../HomePage/CustomBoatLeadModal';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [logo, setLogo] = useState(logoWhite);
  const [showLeadModal, setShowLeadModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
        setLogo(logoBlack);
      } else {
        setIsScrolled(false);
        setLogo(logoWhite);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__content">
        <div className="navbar__logo">
          <a href="/">
            <img src={logo} alt="Logo" />
          </a>
        </div>

        <div className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          <ul className="navbar__centered-links">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about-us">About Us</a>
            </li>
            <li>
              <a href="/services">Services</a>
            </li>
            <li>
              <a href="/blog">Blog</a>
            </li>
          </ul>
        </div>

        <div className="navbar__user-auth">
          <li className="navbar__button">
            <button className="button" onClick={() => setShowLeadModal(true)}>
              Book Now
            </button>
          </li>
        </div>

        <button className="navbar__menu-button" onClick={() => setMenuOpen(!menuOpen)}>
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </button>
      </div>
      {showLeadModal && <CustomBoatLeadModal onClose={() => setShowLeadModal(false)} />}
    </nav>
  );
};

export default Navbar;
